import Crud from '../views/Uf/Crud'
import Entity from '../views/Uf/Add'

let routes = {
    path: '/ufs',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/ufs/add',
            name: 'NewUf',
            component: Entity,
            meta: {
                pageTitle: 'UF',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar UF',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/ufs/edit/:id?',
            name: 'EditUf',
            component: Entity,
            meta: {
                pageTitle: 'UF',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar UF',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/ufs',
            name: 'list-ufs',
            component: Crud,
            meta: {
                pageTitle: 'Lista de UFs',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'UFs',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
